import { jsxs, jsx } from 'react/jsx-runtime';

const styles = {
    wrapper: 'w-full bg-(--color-bg-main-container) py-space-500 px-space-400',
    heading: 'text-center text-h2 text-(--color-text-headline) mb-space-500',
    grid: 'max-w-7xl mx-auto grid gap-space-400',
    item: 'flex flex-col items-center text-center gap-space-200',
    icon: 'w-10 h-10 flex items-center justify-center text-(--color-brand-primary)',
    title: 'text-body-strong text-(--color-text-body)',
    subcopy: 'text-body text-(--color-text-body)',
};
const RegBenefits = ({ heading, benefits }) => {
    return (jsxs("div", { className: styles.wrapper, children: [heading && jsx("h2", { className: styles.heading, children: heading }), jsx("ul", { className: styles.grid, style: { gridTemplateColumns: `repeat(${benefits.length}, 1fr)` }, children: benefits.map((benefit, index) => (jsxs("li", { className: styles.item, children: [jsx("span", { className: styles.icon, "aria-hidden": "true", children: benefit.icon }), jsx("p", { className: styles.title, children: benefit.title }), jsx("p", { className: styles.subcopy, children: benefit.subcopy })] }, `${index}-${benefit.title}`))) })] }));
};

export { RegBenefits };
